import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { LogoutButton } from '@prosolve/common-components-ui'
import ProsolveLogo from '../images/prosolve-logo-slim.png';
import StarLogo from '../images/star-logo.png';
import useFetch from '../hooks/useFetch';
import { getClientSubdomain, checkHasEditEventTemplatePermissions } from '../utils';

export default () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const fetch = useFetch();

  const clientSubdomain = getClientSubdomain()

  const isStarSubdomain = (clientSubdomain === 'star')
  
  const itemStyle = {
    color: '#565656',
    padding: '7px 15px',
    cursor: 'pointer',
    borderRadius: '10px',
    fontSize: '14px'
  }

  const selectedStyle = {
    background: '#F3FBFF',
    color: '#0280c6'
  }

  const onItemClicked = (name) => {
    if (pathname !== `/${name}`) {
      navigate(`${name}`);
    }
  }

  const Tab = ({ name, path }) => {
    let extraStyle;
    if (pathname === '/') {
      extraStyle = (path === 'home' ? selectedStyle : {});
    } else {
      extraStyle = (pathname?.includes(path) ? selectedStyle : {});
    }
    return (
      <div
        style={{
          ...itemStyle,
          ...extraStyle
        }}
        onClick={() => onItemClicked(path)}
      >
        {name}
      </div>
    )
  }

  const hasEditEventTemplatePermissions = checkHasEditEventTemplatePermissions()

  return (
    <div style={{
      position: 'sticky',
      top: '0',
      zIndex: '999',
      display: 'flex',
      height: '39px',
      padding: '0px 20px',
      alignItems: 'center',
      background: '#ffffff',
      color: '#080808',
      borderBottom: '1px solid #C2C9D1',
    }}>
      {
        isStarSubdomain ?
        <img 
          src={StarLogo} 
          style={{ height: '32px', marginRight: '30px', marginLeft: '12px', cursor: 'pointer' }} 
          alt="prosolveLogo" 
          onClick={() => navigate('home')}
        />
        :
        <img 
          src={ProsolveLogo} 
          style={{ height: '45px', marginRight: '20px', cursor: 'pointer' }} 
          alt="prosolveLogo" 
          onClick={() => navigate('home')}
        />
      }
      
      <Tab name='Home' path='home' />
      <div style={{ borderRight: '1px solid #7e7e7e', marginLeft: '5px', marginRight: '7px' }}>
        &nbsp;
      </div>
      {/* {
        !isStarSubdomain &&
        <Tab name='Trainer Dashboard' path='trainer' />
      } */}
      { hasEditEventTemplatePermissions &&
        <Tab name='Design Center' path='design' />
      }
      
      {/* <Tab name='Community' path='community' />
      <Tab name='Events' path='events' />
      <Tab name='Design Center' path='design' /> */}


      <div style={{ flex: 1 }}>&nbsp;</div>
      <LogoutButton fetch={fetch} />
    </div>
  )
}